module.exports = __webpack_public_path__ + "img/face-surprise.c07ae3a6.svg";